export default __webpack_public_path__ + "static/media/thsarabunnew-webfont.626483d0.woff";